import { render, staticRenderFns } from "./PaymentAndKioskItems.vue?vue&type=template&id=0b9f2664&"
import script from "./PaymentAndKioskItems.vue?vue&type=script&lang=js&"
export * from "./PaymentAndKioskItems.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAndKioskItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports